export default __webpack_public_path__ + "static/media/google_sync_icon.e7f89f83.png";